import { useCallback } from 'react';
import {
  StorageFileOpenPickerPopup,
  type StorageFileOpenPickerSelection
} from '../fileBrowser/StorageFileOpenPickerPopup';
import { isAllowedOfficeFileForKind, type DocumentEditorKind } from './documentFileTypes';

export type DocumentOpenPickerSelection = StorageFileOpenPickerSelection;

export type DocumentOpenPickerPopupProps = {
  visible: boolean;
  kind: DocumentEditorKind;
  onClose: () => void;
  onOpen: (selection: DocumentOpenPickerSelection) => void;
};

export function DocumentOpenPickerPopup({
  visible,
  kind,
  onClose,
  onOpen
}: DocumentOpenPickerPopupProps) {
  const accept = useCallback(
    (fileName: string) => isAllowedOfficeFileForKind(fileName, kind),
    [kind]
  );

  return (
    <StorageFileOpenPickerPopup
      visible={visible}
      title={kind === 'spreadsheet' ? 'Open spreadsheet' : 'Open document'}
      accept={accept}
      onClose={onClose}
      onOpen={onOpen}
    />
  );
}
